import React from 'react';
import Block from '../../../block/Block';
import IconButton from '../../../icon-button/IconButton';
import PrintIcon from '../../../icons/print-icon/PrintIcon';
import Translatable from '../../../translatable/Translatable';
import styles from './CmsPrint.less';

var CmsPrint = function CmsPrint() {
  return /*#__PURE__*/React.createElement(Block, {
    className: styles.printWrapper
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: window.print,
    className: styles.print
  }, /*#__PURE__*/React.createElement(PrintIcon, null), /*#__PURE__*/React.createElement(Translatable, {
    id: "cms.print"
  })));
};

export default CmsPrint;